import { render, staticRenderFns } from "./JiaolianList.vue?vue&type=template&id=def6b64e&scoped=true&"
import script from "./JiaolianList.vue?vue&type=script&lang=js&"
export * from "./JiaolianList.vue?vue&type=script&lang=js&"
import style0 from "./JiaolianList.vue?vue&type=style&index=0&id=def6b64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def6b64e",
  null
  
)

export default component.exports